import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-info-row__content" }
const _hoisted_2 = { class: "flex-center" }
const _hoisted_3 = {
  class: /*@__PURE__*/_normalizeClass(['m-0', 'c-info-row__title'])
}
const _hoisted_4 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
			'c-info-row',
			{ 'c-info-row--active': _ctx.active },
			{ 'c-info-row__border-top': _ctx.hasDividerStart },
			{ 'c-info-row__border-bottom': _ctx.hasDividerEnd },
			{ 'cursor-pointer': !_ctx.disabled }
		]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (!_ctx.disabled ? _ctx.clickAction() : () => {}))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['flex-space', 'width-100', 'c-info-row__container', { 'c-info-row--disabled': _ctx.disabled }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1),
          _createElementVNode("span", {
            class: _normalizeClass([
							'ml-6',
							'c-info-row__icon',
							{ 'c-info-row__icon--active': _ctx.active },
							{ 'c-info-row__icon--disabled': _ctx.disabled },
						])
          }, [
            _renderSlot(_ctx.$slots, "iconTitle", {}, undefined, true)
          ], 2)
        ]),
        _createElementVNode("div", {
          class: "c-info-row__info-text mt-2",
          title: _ctx.titleInfo
        }, _toDisplayString(_ctx.titleInfo), 9, _hoisted_4)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(['flex-row', 'c-info-row__info', { 'cursor-pointer': !_ctx.disabled }])
      }, [
        _createElementVNode("span", {
          class: _normalizeClass([
						'c-info-row__icon',
						{ 'c-info-row__icon--active': _ctx.active },
						{ 'c-info-row__icon--disabled': _ctx.disabled },
					])
        }, [
          _renderSlot(_ctx.$slots, "icon", {}, undefined, true)
        ], 2)
      ], 2)
    ], 2)
  ], 2))
}